<template>
<!--

    下载储存区弹窗内容组件
 -->
  <div v-loading="loading" class="container clearFix">
    <!-- <div class="refersh">
            <el-button type="primary" @click="refresh">刷新</el-button>
        </div>
        -->
    <el-table
      :data="downloadSaveTableData"
      style="width: 100%; margin-bottom: 10px"
    >
      <el-table-column prop="downloadName" label="账单名称"> </el-table-column>
      <el-table-column prop="createTime" label="下载时间"> </el-table-column>
      <el-table-column prop="exportStatus" label="下载状态">
        <template slot-scope="scope">
          {{ scope.row.exportStatus | exportStatusFilter }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <a
            :href="scope.row.url"
            v-if="scope.row.exportStatus === 100 && scope.row.url"
            class="download_link"
          >
            导出
          </a>
          <span v-else>--</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pag_container">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="10"
        @current-change="tablePageChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { requestExportHistory,  advanceExportHistory  } from "../../api/apiMap/index.js";
export default {
  props: ["appId", "splitId", "activeName", "userid"],
  created() {
    this.getTableData(this.appId, 1, true, this.splitId);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  data() {
    return {
      downloadSaveTableData: [],
      loading: false,
      currentPage: 1,
      total: 0,
      timer: null,
    };
  },
  filters: {
    exportStatusFilter(val) {
      return val + "%";
      // switch(val) {
      //     case 0:
      //         return '0%';
      //     case 1:
      //         return '50%';
      //     case 2:
      //         return '100%';
      //     default:
      //         return '';
      // }
    },
  },
  methods: {
    // 获取表格数据
    getTableData(appId, currentPage = 1, bool, splitId = '') {
      if (bool) {
        this.loading = true;
      }
      if (this.activeName === 'enjoyNowPayLaterBill') {
        let params = {
            userid: this.userid,
            currentPage,
            pageSize: 10,
            timestamp: new Date().getTime() + "",
          }
          advanceExportHistory(params).then(result => {
            this.showResult(result, bool);
          }).catch(() => {
            this.$message.error("网络错误");
            this.loading = false;
          });
      } else {
        appId = splitId == "" ? appId : splitId;
        var type = splitId == "" ? 0 : 2;
        requestExportHistory({ appId, currentPage, type })
          .then((result) => {
            this.showResult(result, bool);
          }).catch(() => {
            this.$message.error("网络错误");
            this.loading = false;
          });
      }
    },
    showResult(result, bool) {
      if (result.errno === 0) {
            this.downloadSaveTableData = result.data ? result.data.data : [];
          this.total = result.data ? result.data.totalCount : 0;
            if (bool) {
              this.loading = false;
            }
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              this.refresh();
            }, 6000);
      } else {
            this.$message.error(result.errmsg || result.msg || "");
            if (bool) {
              this.loading = false;
            }
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              this.refresh();
            }, 6000);
        }
    },
    // 点击刷新按钮
    refresh() {
      this.getTableData(this.appId, this.currentPage, false);
    },
    // 翻页
    tablePageChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData(this.appId, this.currentPage, true);
    },
  },
};
</script>
<style lang="less" scope>
    .container {
        position: relative;
        .refersh {
            transform: scale(80%);
            transform-origin: 0;
            position: absolute;
            left: 5px;
            top: -37px;
        }
        .download_link {
            text-decoration: none;
            color: #1d98ff;
        }
        .pag_container {
            float: right;
            margin-right: 20px;
        }
    }
    .clearFix {
        &::before,
        &::after {
            content: '';
            display: block;
            clear: both;
        }
    }
</style>
